import { Injectable } from '@angular/core';
import { ConnectionService } from './conexion.service';

@Injectable({
  providedIn: 'root'
})
export class VideoService {

  collection :string = 'lastVideos';

  private data : Promise<any[]> = null;
  constructor(
    private connectionServ: ConnectionService
  ) {
    this.data = this.connectionServ.read2<any>(this.collection);
   }

  readlastVideo(){
    return this.data;
  }
}
